import Box from "./Box";
import BrandNav from "./BrandNav";
import Head from "next/head";
import Image from "./Image";
import MobBrandMenu from "./MobBrandMenu";
import PropTypes from "prop-types";
import Text from "./Text";
import BrandHomepageHeader from "./BrandHomepageHeader";

function PageContentBrand({ showHeader, children, brandMenuData, brand }) {
  return (
    <>
      {brand.active === false && (
        <Head>
          <meta name="robots" content="noindex"></meta>
        </Head>
      )}
      <Box pt={60} mt={-60} flex={1}>
        <MobBrandMenu navItems={brandMenuData} />
        {showHeader && <BrandHomepageHeader brand={brand} />}

        <BrandNav brand={brand} navItems={brandMenuData} />
        {children}
      </Box>
    </>
  );
}

export default PageContentBrand;

PageContentBrand.propTypes = {
  showHeader: PropTypes.bool,
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
    headerImage: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }),
  }),
};
